import { sharedLowlight } from '../extensions/tiptapShared';

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function hastToHtml(node: {
  type?: string;
  value?: string;
  tagName?: string;
  properties?: { className?: string | string[] };
  children?: unknown[];
}): string {
  if (!node) return '';
  if (node.type === 'text') return escapeHtml(node.value || '');
  const children = (node.children || []) as Parameters<typeof hastToHtml>[0][];
  if (node.type === 'root' || !node.tagName) {
    return children.map(hastToHtml).join('');
  }
  const className = node.properties?.className;
  const cls = Array.isArray(className) ? className.join(' ') : className || '';
  const classAttr = cls ? ` class="${escapeHtml(cls)}"` : '';
  return `<${node.tagName}${classAttr}>${children.map(hastToHtml).join('')}</${node.tagName}>`;
}

function languageFromClassName(className: string): string | null {
  const match = className.match(/(?:^|\s)language-([a-z0-9_+-]+)/i);
  return match ? match[1] : null;
}

export function highlightCodeBlocksHtml(html: string): string {
  if (typeof window === 'undefined' || !html) return html;
  const doc = new DOMParser().parseFromString(
    `<div id="bh-snippet-root">${html}</div>`,
    'text/html'
  );
  const root = doc.getElementById('bh-snippet-root');
  if (!root) return html;

  root.querySelectorAll('pre code').forEach(codeEl => {
    const source = codeEl.textContent || '';
    if (!source) return;
    const lang = languageFromClassName(codeEl.className);
    try {
      const tree =
        lang && sharedLowlight.registered(lang)
          ? sharedLowlight.highlight(lang, source)
          : sharedLowlight.highlightAuto(source);
      codeEl.innerHTML = hastToHtml(tree as Parameters<typeof hastToHtml>[0]);
      codeEl.classList.add('hljs');
    } catch {
      return;
    }
  });

  return root.innerHTML;
}
